var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-switch-screen" },
    [
      _vm.loading
        ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("chatWindow.systemStatus"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "SupsisButton",
              { attrs: { ghost: "" }, on: { click: _vm.refresh } },
              [
                _c(
                  "div",
                  { staticClass: "btn-refresh", on: { click: _vm.refresh } },
                  [
                    _c("span", { staticClass: "shortcut-keyboard" }, [
                      _vm._v(" R "),
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("refresh"),
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatWindow.refresh")) +
                        "\n                "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.close } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("close")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("chatWindow.close")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "summary" }, [
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "key" }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.totalCustomers"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getSummary().totalCustomers)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "key" }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.totalAnswered"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getSummary().totalAnswered)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "key" }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.waitingAnswer"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getSummary().waitingAnswer)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "key" }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.totalAgentInChat"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getSummary().totalAgentInChat)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "key" }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.onlineAgentCount"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getSummary().onlineAgentCount)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "agent-filters" },
        [
          _vm._v("\n        Filter By\n        "),
          _c("CircleUserSelect", {
            attrs: {
              users: _vm.getOnlineUsers(),
              value: _vm.selectedUserId,
              nullable: "",
            },
            on: { input: _vm.changeAgentFilter },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "groups mt-2" },
        _vm._l(
          _vm.$_.orderBy(_vm.getGroups(), "order").map(function (x) {
            return x.id
          }),
          function (group) {
            return _vm.isVisibleGroup(_vm.getGroups()[group])
              ? _c("div", { key: group, staticClass: "group" }, [
                  _c(
                    "div",
                    { staticClass: "group-header" },
                    [
                      _vm.getGroups()[group].id
                        ? _c("AgentAvatar", {
                            key: _vm.getGroups()[group].id,
                            attrs: {
                              size: 50,
                              "font-size": 15,
                              userID: _vm.getGroups()[group].id,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h2", [
                        _vm._v(
                          _vm._s(_vm.agentName(_vm.getGroups()[group].id))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "group-stats" },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("star"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "group-stats-item total" }, [
                            _c("span", { staticClass: "key" }, [
                              _vm._v(
                                _vm._s(_vm.$t("chatWindow.totalCustomer"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getGroupStats(_vm.getGroups()[group])
                                    .totalCustomers
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("star"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "group-stats-item answered" },
                            [
                              _c("span", { staticClass: "key" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("chatWindow.answered"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getGroupStats(_vm.getGroups()[group])
                                      .answered
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("star"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "group-stats-item unanswered" },
                            [
                              _c("span", { staticClass: "key" }, [
                                _vm._v(_vm._s(_vm.$t("chatWindow.unanswered"))),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getGroupStats(_vm.getGroups()[group])
                                      .unanswered
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              attrs: { ghost: "" },
                              on: {
                                click: function () {
                                  return _vm.watchAll(_vm.getGroups()[group].id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        Tümünü Canlı İzle\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "customers" },
                    _vm._l(_vm.getGroups()[group].items, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.name,
                          staticClass: "customer-card",
                          class: { selected: _vm.selectedIndex === item.index },
                          attrs: { "data-index": item.index },
                          on: {
                            click: function () {
                              return _vm.selectWithIndex(item.index)
                            },
                          },
                        },
                        [
                          item.index < 9
                            ? _c(
                                "span",
                                { staticClass: "index-shortcut-keyboard" },
                                [_vm._v(_vm._s(item.index + 1))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "customer-info" }, [
                            _c("div", { staticClass: "first-line" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("person"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "texts" }, [
                                _c("div", { staticClass: "customer-name" }, [
                                  _vm._v(_vm._s(item.visitor.fullname)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "customer-agent" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("chatWindow.agent")) +
                                      ":\n                                    " +
                                      _vm._s(
                                        _vm.agentName(_vm.getGroups()[group].id)
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "metas" }, [
                              _c(
                                "div",
                                {
                                  key:
                                    _vm.dateRenderKey +
                                    "-" +
                                    _vm.getGroups()[group].agent +
                                    "-" +
                                    item._id,
                                  staticClass: "customer-duration",
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("timer"),
                                  ]),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.fromNow(item.createdDate)) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "customer-status",
                                  class: {
                                    answered: item.answerStatus === "answered",
                                    waiting: item.answerStatus !== "answered",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        item.answerStatus === "answered"
                                          ? "Answered"
                                          : "Waiting Answer"
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e()
          }
        ),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }